module.exports = __webpack_public_path__ + "static/media/six.7a4d742d.svg";